import { ICustomBinding } from 'radpresentation.htmlclient.defaultviewextensions';

import TaskDescriptionBinding from '@/Infrastructure/CustomBindings/TaskDescriptionBinding';

([
    new TaskDescriptionBinding(),
] as Array<ICustomBinding>)
    .forEach(binding => binding.initBinding());
